import { Link, useLocation } from 'react-router-dom'
import { MobileNav } from './MobileNav'
import { useAuthStore } from '@/shared/stores/authStore'
import { Button } from '@/shared/components/ui/button'
import { TimerWidget } from '@/features/timer/components/TimerWidget'
import { User, Clock } from 'lucide-react'

export function MobileHeader() {
  const { user, logout } = useAuthStore()
  const location = useLocation()
  const isTimerPage = location.pathname === '/timer'

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 md:hidden">
      <div className="flex h-14 items-center px-4">
        <MobileNav />
        
        <div className="flex-1 flex items-center justify-center">
          <Link to="/" className="flex items-center gap-2">
            <Clock className="h-5 w-5" />
            <span className="font-semibold">TimeTracker</span>
          </Link>
        </div>

        <div className="flex items-center gap-2">
          {user && (
            <Button
              variant="ghost"
              size="icon"
              className="h-10 w-10 rounded-full"
              onClick={logout}
            >
              <User className="h-5 w-5" />
            </Button>
          )}
        </div>
      </div>

      {/* Show timer widget in header on mobile when not on timer page */}
      {!isTimerPage && (
        <div className="border-t px-4 py-2">
          <TimerWidget compact />
        </div>
      )}
    </header>
  )
}

export default MobileHeader
